module.exports = __webpack_public_path__ + "ecc01f0ee14ef4e1e5e94294df65ae53.svg";